import { render, staticRenderFns } from "./roleDialog.vue?vue&type=template&id=1833c393&scoped=true"
import script from "./roleDialog.vue?vue&type=script&lang=js"
export * from "./roleDialog.vue?vue&type=script&lang=js"
import style0 from "./roleDialog.vue?vue&type=style&index=0&id=1833c393&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1833c393",
  null
  
)

export default component.exports